// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#errorModal .disabled {
  color: #d0d0d0;
}
#errorModal .error-box {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
}
#errorModal p {
  margin-bottom: 0;
  padding: 10px;
}
#errorModal p:nth-child(even) {
  background-color: #f9f9f9;
}
#errorModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#errorModal .icon-toast {
  margin-right: 15px;
  font-size: 1.6rem;
  position: relative;
  top: -2px;
}
#errorModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#errorModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#errorModal .btn-link:focus {
  text-decoration: none;
}
#errorModal .btn-secondary {
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#errorModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
@media (min-width: 2024px) {
#errorModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#errorModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#errorModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#errorModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#errorModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#errorModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}
#errorModal {
  /* Hide the browser's default checkbox */
}
#errorModal .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
#errorModal {
  /* Create a custom checkbox */
}
#errorModal .checkmark {
  position: absolute;
  margin-left: -14px;
  margin-top: 1px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
#errorModal {
  /* When the checkbox is checked, add a blue background */
}
#errorModal .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
#errorModal {
  /* Create the checkmark/indicator (hidden when not checked) */
}
#errorModal .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
#errorModal {
  /* Show the checkmark when checked */
}
#errorModal .container input:checked ~ .checkmark:after {
  display: block;
}
#errorModal {
  /* Style the checkmark/indicator */
}
#errorModal .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
